import { Trash2 } from "lucide-react";

interface CrmContactTagsEditorProps {
  tags: string[];
  tagInput: string;
  removingTag: string | null;
  error: string | null;
  onTagInputChange: (value: string) => void;
  onAddTag: () => void;
  onRemoveTag: (tag: string) => void;
}

export function CrmContactTagsEditor({
  tags,
  tagInput,
  removingTag,
  error,
  onTagInputChange,
  onAddTag,
  onRemoveTag,
}: CrmContactTagsEditorProps) {
  return (
    <div className="border-b border-[var(--color-border)] p-4">
      <p className="mb-2 text-xs font-medium uppercase text-[var(--color-muted-foreground)]">Tags</p>
      <div className="flex flex-wrap gap-1">
        {tags.map((tag) => (
          <span key={tag} className="inline-flex items-center gap-1 rounded-full bg-[var(--color-primary-light)] px-2 py-0.5 text-xs text-[var(--color-primary)]">
            <span>{tag}</span>
            <button
              type="button"
              aria-label={`Remove tag ${tag}`}
              onClick={() => { onRemoveTag(tag); }}
              disabled={removingTag === tag}
              className="rounded-full p-0.5 text-[var(--color-primary)] transition-colors hover:bg-[var(--color-primary)]/10 hover:text-[var(--color-primary-hover)] disabled:cursor-not-allowed disabled:opacity-60"
            >
              <Trash2 className="h-3 w-3" />
            </button>
          </span>
        ))}
      </div>
      {error ? (
        <p className="mt-2 text-xs text-[var(--color-destructive)]">{error}</p>
      ) : null}
      <div className="mt-2 flex gap-2">
        <input
          type="text"
          value={tagInput}
          onChange={(event) => onTagInputChange(event.target.value)}
          onKeyDown={(event) => {
            if (event.key === "Enter") onAddTag();
          }}
          placeholder="Add tag..."
          className="flex-1 rounded-md border border-[var(--color-border)] bg-[var(--color-background)] px-2 py-1 text-sm text-[var(--color-foreground)] placeholder:text-[var(--color-muted-foreground)] focus:outline-none focus:ring-2 focus:ring-[var(--color-primary)]/30"
        />
        <button
          type="button"
          onClick={() => { onAddTag(); }}
          className="rounded-md bg-[var(--color-primary)] px-3 py-1 text-xs text-[var(--color-primary-foreground)] hover:bg-[var(--color-primary-hover)] transition-colors"
        >
          Add
        </button>
      </div>
    </div>
  );
}
